import {MakeStore, StoreObject} from "../../stem-core/src/state/Store.js";
import {field} from "../../stem-core/src/state/StoreField.js";
import {BaseLogMessage} from "./misc/BaseLogMessage.js";

class BlinkLogMessage extends BaseLogMessage {
    @field(String) app;
    @field(String) hostname;
}

export const BlinkLogMessageStore = MakeStore("BlinkLogMessage", BlinkLogMessage);